
import { Component, Vue } from "vue-property-decorator";
@Component
export default class Header extends Vue {
  public isIOs = false;

  public mounted() {
    //   url截取token
    // const obj: any = this.$fn.parseQuery(window.location.href);
    if (this.$fn.cookies.getIsios()) {
      this.isIOs = true;
    }
  }
  public onClickRight() {
    this.$router.push({ path: "/mywantobuy" });
  }
  public onClickLeft() {
    this.$router.go(-1);
  }
}
